import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/helpers/services/api.service';
import { HttpService } from 'src/app/helpers/services/http.service';
import { ToastresService } from 'src/app/helpers/services/toaster.service';

@Component({
  selector: 'app-reject',
  templateUrl: './reject.component.html',
  styleUrls: ['./reject.component.css'],
})
export class RejectComponent {
  public id: any;
  public type: any;
  public rejectReason: any;

  public quoteFlowStatus: any;
  public taskType: number;

  form: FormGroup;
  submitted: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public httpService: HttpService,
    private api: ApiService,
    private toastrsService: ToastresService,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  get f() {
    return this.form.controls;
  }

  submit() {
    this.submitted = true;
    if (this.form.invalid) return;

    if (this.type == 'quote') {
      let status: number = 0;

      switch (this.quoteFlowStatus) {
        case 20: // Submitted by User
          status = 30; // Rejected by Admin
          break;

        case 40: // Submitted by Admin
          status = 50; // Rejected by Client
          break;

        case 50: // Rejected by Client
          status = 30; // Rejected by Admin
          break;
      }

      this.httpService
        .action(
          this.api.quotes.updateStatus(this.id),
          { status, reason: this.f.Reason.value },
          'rejectLoader',
        )
        .subscribe({
          next: (res: any) => {
            if (res.success) {
              this.activeModal.close();
              this.toastrsService.ShowSuccess(res.msg);
            } else {
              this.toastrsService.ShowError(res.msg);
            }
          },
        });
    }

    if (this.type == 'story') {
      this.httpService
        .action(
          this.api.stories.reject(this.id),
          { reason: this.f.Reason.value },
          'rejectLoader',
        )
        .subscribe({
          next: (res: any) => {
            if (res.success) {
              this.activeModal.close();
              this.toastrsService.ShowSuccess(res.msg);
            } else {
              this.toastrsService.ShowError(res.msg);
            }
          },
        });
    }

    if (this.type == 'task') {
      let apiUrl = '';
      if (this.taskType == 1) {
        apiUrl = this.api.workspaceProjectTasks.reject(this.id);
      } else if (this.taskType == 2) {
        apiUrl = this.api.meetingTasks.reject(this.id);
      } else {
        apiUrl = this.api.generalTasks.reject(this.id);
      }

      this.httpService
        .action(apiUrl, { reason: this.f.Reason.value }, 'rejectLoader')
        .subscribe({
          next: (res: any) => {
            if (res.success) {
              this.activeModal.close();
              this.toastrsService.ShowSuccess(res.msg);
            } else {
              this.toastrsService.ShowError(res.msg);
            }
          },
        });
    }

    if (this.type == 'contract') {
      this.httpService
        .action(
          this.api.contracts.reject(this.id),
          { reason: this.f.Reason.value },
          'rejectLoader',
        )
        .subscribe({
          next: (res: any) => {
            if (res.success) {
              this.activeModal.close();
              this.toastrsService.ShowSuccess(res.msg);
            } else {
              this.toastrsService.ShowError(res.msg);
            }
          },
        });
    }
  }

  getRejectReason(): string {
    if (this.type == 'quote') return this.rejectReason;
    if (this.type == 'story') return this.rejectReason;
    if (this.type == 'task') return this.rejectReason;
    if (this.type == 'contract') return this.rejectReason;
    return '';
  }

  initForm() {
    this.form = new FormGroup({
      Reason: new FormControl(
        {
          value: this.getRejectReason(),
          disabled: this.rejectReason ? true : false,
        },
        Validators.required,
      ),
    });
  }
}
